import * as CustomerService from '../../../services/customerService'
import verifyAccountResult from './verifyAccountResult'

const validateVerification = async (
  firstName,
  lastName,
  suffix,
  streetAddress,
  apt,
  city,
  stateCode,
  zipCode,
  mobile,
  mobileType,
  branchId,
  accountNumber,
  token
) => {
  let response = await CustomerService.verify(
    firstName,
    lastName,
    suffix,
    streetAddress,
    apt,
    city,
    stateCode,
    zipCode,
    mobile,
    mobileType,
    branchId,
    accountNumber,
    token
  )

  return new verifyAccountResult(response.isVerified)
}

export default validateVerification
